export var ELocale;
(function (ELocale) {
    ELocale["EN"] = "en_UK";
    ELocale["NL"] = "nl_BE";
    ELocale["FR"] = "fr_FR";
    ELocale["INTERNAL"] = "internal";
})(ELocale || (ELocale = {}));
